module.exports = __webpack_public_path__ + "assets/62f755893c370d26f980f1b045457391.png";